export const categories = [
  {
    slug: "zixun",
    name: "最新资讯",
    description: "行业动态、热门话题、前沿趋势一网打尽",
    icon: "ri-newspaper-line",
    count: 128,
  },
  {
    slug: "jiaocheng",
    name: "实用教程",
    description: "手把手教学，从入门到精通",
    icon: "ri-book-open-line",
    count: 96,
  },
  {
    slug: "ziyuan",
    name: "资源下载",
    description: "精选优质资源，一键获取",
    icon: "ri-download-2-line",
    count: 74,
  },
  {
    slug: "gongju",
    name: "效率工具",
    description: "提升工作效率的利器推荐",
    icon: "ri-tools-line",
    count: 53,
  },
  {
    slug: "shenghuo",
    name: "生活百科",
    description: "日常小技巧，让生活更美好",
    icon: "ri-lightbulb-line",
    count: 87,
  },
  {
    slug: "keji",
    name: "科技前沿",
    description: "探索科技世界的无限可能",
    icon: "ri-cpu-line",
    count: 62,
  },
];

export type Category = (typeof categories)[number];